import localStorageKeys from '@/constants/local-storage-keys';

const HISTORY_LENGTH = 3;

export const useRecentLocations = () => {
  const recentLocations = useLocalStorage(localStorageKeys.RECENT, []);

  function add(addId) {
    recentLocations.value = [addId]
      .concat(recentLocations.value.filter((id) => id !== addId))
      .slice(0, HISTORY_LENGTH + 1);

    return Promise.resolve();
  }

  function get(excludeId) {
    return recentLocations.value
      .filter((id) => id !== excludeId)
      .slice(0, HISTORY_LENGTH);
  }

  return { data: recentLocations, add, get };
};
